import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { API_URL } from '../Utils/Url.jsx'
// import { RootColorTheme } from "../css/rootColorTheme";

// A random id kept in this browser, so the admin's live "browsing now" count can tell
// one anonymous visitor from another (and not count them twice across tabs).
const clientId = () => {
  try {
    let id = localStorage.getItem("tvfm_client_id");
    if (!id) {
      id = (window.crypto && window.crypto.randomUUID) ? window.crypto.randomUUID() : `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 12)}`;
      localStorage.setItem("tvfm_client_id", id);
    }
    return id;
  } catch (e) {
    return undefined;
  }
};

// Maintenance mode: when the admin closes the shop every API call answers 503 with maintenance:true.
// Any such answer (from this file or a direct fetch) puts a full-screen notice over the site.
const showMaintenance = (info) => {
  try {
    if (document.getElementById("tvfm-maintenance")) return;
    const box = document.createElement("div");
    box.id = "tvfm-maintenance";
    box.setAttribute("style", "position:fixed;inset:0;z-index:2147483647;background:#fff;display:flex;align-items:center;justify-content:center;padding:24px;text-align:center;font-family:Mulish,Arial,sans-serif");
    const card = document.createElement("div");
    card.setAttribute("style", "max-width:520px");
    const mark = document.createElement("div");
    mark.textContent = "🛠️";
    mark.setAttribute("style", "font-size:64px;margin-bottom:12px");
    const h = document.createElement("h1");
    h.textContent = (info && info.title) || "We will be back soon";
    h.setAttribute("style", "margin:0 0 10px;font-size:28px;color:#0f172a");
    const p = document.createElement("p");
    p.textContent = (info && info.message) || "We are making some improvements. Please try again in a little while.";
    p.setAttribute("style", "margin:0 0 14px;font-size:16px;line-height:1.5;color:#475569");
    card.appendChild(mark); card.appendChild(h); card.appendChild(p);
    if (info && info.estimatedEnd) {
      const e = document.createElement("p");
      e.textContent = "Expected back: " + new Date(info.estimatedEnd).toLocaleString("en-IN");
      e.setAttribute("style", "margin:0 0 18px;font-size:14px;font-weight:700;color:#0f172a");
      card.appendChild(e);
    }
    const b = document.createElement("button");
    b.textContent = "Try again";
    b.setAttribute("style", "padding:10px 22px;border:0;border-radius:10px;background:#ffd102;font-weight:800;font-size:15px;cursor:pointer");
    b.onclick = () => window.location.reload();
    card.appendChild(b);
    box.appendChild(card);
    document.body.appendChild(box);
  } catch (e) { /* the notice is best effort */ }
};
if (typeof window !== "undefined" && !window.__tvfmFetchPatched) {
  window.__tvfmFetchPatched = true;
  const nativeFetch = window.fetch.bind(window);
  window.fetch = async (...args) => {
    const response = await nativeFetch(...args);
    if (response.status === 503) {
      try {
        const info = await response.clone().json();
        if (info && info.maintenance) showMaintenance(info);
      } catch (e) { /* not a maintenance answer */ }
    }
    return response;
  };
}

const startLoader = () => {
  // Loader removed as per user request to remove SweetAlert
};

const stopLoader = () => {
  // Loader removed as per user request to remove SweetAlert
};

const handleSessionExpiry = () => {
  const userType = sessionStorage.getItem("website_userType") || localStorage.getItem("website_userType");
  const vendorToken = localStorage.getItem('vendorToken');

  const keepId = localStorage.getItem("tvfm_client_id");
  sessionStorage.clear();
  localStorage.clear();
  if (keepId) localStorage.setItem("tvfm_client_id", keepId);

  if (userType === 'vendor' || vendorToken) {
    window.location.replace('/vendor/login');
  } else {
    window.location.replace('/signin');
  }
};

const getData = async (route, queryParamsArg, token, isToastNeeded = true, module = '') => {

  try {
    // startLoader();
    const URL_ROUTE = `${API_URL}${route}`;
    const headers = {
      ...(token && { Authorization: `${token}` }),
      "Content-Type": "application/json",
      "x-app-platform": "website",
      ...(clientId() && { "x-client-id": clientId() }),
    };

    let url = URL_ROUTE;
    if (queryParamsArg) {
      const queryParams = new URLSearchParams(queryParamsArg).toString();
      url += `?${queryParams}`;
    }

    const options = {
      method: 'GET',
      headers: headers,
    };

    const response = await fetch(url, options);
    let responseData;
    try {
      responseData = await response.json();
    } catch (err) {
      responseData = { error: true, message: 'Server error or invalid response' };
    }
    const isSessionExpired = response.status === 401 || 
                             responseData?.message === "Session expired" || 
                             responseData?.message === "Session Expired" || 
                             responseData?.message === "Invalid or expired token";

    if (isSessionExpired) {
      handleSessionExpiry();
      return responseData;
    }
    if (response.status === 200) {
      console.log(responseData.message);
    }
    if (isToastNeeded && response.status === 200) {
      toast.success(responseData.message);
    }
    if (isToastNeeded) {
      if (response?.status === 404) {
        // Error intentionally not toasted globally - handled on webpage
      }
    }
    // stopLoader();
    return responseData;
  } catch (error) {
    console.error(error);
    if (isToastNeeded) {
      // Error intentionally not toasted globally - handled on webpage
    }
    stopLoader()
    throw error;
  }
};

const postData = async (route, data, token, isLoaderRequired = true, isToastNeeded = true) => {
  try {
    // if (isLoaderRequired) startLoader();
    const URL_ROUTE = `${API_URL}${route}`;

    const headers = {
      ...(token && { Authorization: `${token}` }),
      "Content-Type": "application/json",
      "x-app-platform": "website",
      ...(clientId() && { "x-client-id": clientId() }),
    };

    const response = await fetch(URL_ROUTE, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(data),
    });

    let responseData;
    try {
      responseData = await response.json();
    } catch (err) {
      responseData = { error: true, message: 'Server error or invalid response' };
    }

    const isSessionExpired = response.status === 401 || 
                             responseData?.message === "Session expired" || 
                             responseData?.message === "Session Expired" || 
                             responseData?.message === "Invalid or expired token";

    if (isSessionExpired) {
      handleSessionExpiry();
      return responseData;
    }

    if (!response.ok) {
      throw new Error(responseData.message || "Failed to fetch");
    }
    if (isToastNeeded && response.status === 200) {
      toast.success(responseData.message);
    }
    if (isLoaderRequired) stopLoader();
    return responseData;
  } catch (error) {
    if (isToastNeeded) {
      // Error intentionally not toasted globally - handled on webpage
    }
    stopLoader();
    throw error;
  }
};

const postFileUpload = async (route, data, token) => {
  try {
    startLoader();
    const URL_ROUTE = `${API_URL}${route}`;
    const headers = {
      Authorization: `${token}`,
    };

    const response = await fetch(URL_ROUTE, {
      method: "POST",
      headers: headers,
      body: data,
    });
    let responseData;
    try {
      responseData = await response.json();
    } catch (err) {
      responseData = { error: true, message: 'Server error or invalid response' };
    }
    if (!response.ok) {
      throw new Error(responseData.message || "Failed to fetch");
    }
    if (response.status === 401 || responseData?.message === "Invalid or expired token") {
      handleSessionExpiry();
      return responseData;
    }
    if (response.status === 200) {
      toast.success(responseData.message);
    }
    stopLoader();
    return responseData;
  } catch (error) {
    // Error intentionally not toasted globally - handled on webpage
    console.error(error);
    stopLoader();
    throw error;
  }
};

const FileUpload = async (route, data) => {
  try {
    startLoader();
    const URL_ROUTE = `${API_URL}${route}`;
    const response = await fetch(URL_ROUTE, {
      method: "POST",
      body: data,
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Failed to fetch");
    }
    const responseData = await response.json();
    if (response.status === 401 || responseData?.message === "Invalid or expired token") {
      handleSessionExpiry();
      return responseData;
    }
    if (response.status === 200) {
      toast.success(responseData.message);
    }
    stopLoader();
    return responseData;
  } catch (error) {
    console.error(error);
    // Error intentionally not toasted globally - handled on webpage
    stopLoader();
    throw error;
  }
};

const patchData = async (route, data, token, isLoaderRequired = true, isToastNeeded = true) => {
  try {
    // startLoader();
    const URL_ROUTE = `${API_URL}${route}`;
    const headers = {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    };

    const response = await fetch(URL_ROUTE, {
      method: "PATCH",
      headers: headers,
      body: JSON.stringify(data),
    });
    const responseData = await response.json();
    if (response.status === 401 || responseData?.message === "Invalid or expired token") {
      handleSessionExpiry();
      return responseData;
    }
    if (isToastNeeded && response.status === 200) {
      toast.success(responseData.message);
    }
    stopLoader();
    return responseData;
  } catch (error) {
    console.error(error);
    // Error intentionally not toasted globally - handled on webpage
    stopLoader();
    throw error;
  }
};

const putData = async (route, data, token, isLoaderRequired = true, isToastNeeded = true) => {
  try {
    startLoader();
    const URL_ROUTE = `${API_URL}${route}`;
    const isFormData = data instanceof FormData;
    const headers = {
      Authorization: `${token}`,
      ...(isFormData ? {} : { "Content-Type": "application/json" }),
    };

    const response = await fetch(URL_ROUTE, {
      method: "PUT",
      headers: headers,
      body: isFormData ? data : JSON.stringify(data),
    });
    let responseData;
    try {
      responseData = await response.json();
    } catch (err) {
      responseData = { error: true, message: 'Server error or invalid response' };
    }
    if (response.status === 401 || responseData?.message === "Invalid or expired token") {
      handleSessionExpiry();
      return responseData;
    }
    if (isToastNeeded && response.status === 200) {
      toast.success(responseData.message);
    }
    stopLoader();
    return responseData;
  } catch (error) {
    console.error(error);
    // Error intentionally not toasted globally - handled on webpage
    stopLoader();
    throw error;
  }
};

const deleteData = async (route, data, token, isLoaderRequired = true, isToastNeeded = true) => {
  try {
    // startLoader();
    const URL_ROUTE = `${API_URL}${route}`;
    const headers = {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    };

    const options = {
      method: "DELETE",
      headers: headers,
    };

    if (data) {
      options.body = JSON.stringify(data);
    }

    const response = await fetch(URL_ROUTE, options);
    let responseData = {};
    const text = await response.text();
    if (text) {
      responseData = JSON.parse(text);
    }
    if (response.status === 401 || responseData?.message === "Invalid or expired token") {
      handleSessionExpiry();
      return responseData;
    }
    if (isToastNeeded && response.status === 200) {
      toast.success(responseData.message);
    }
    stopLoader();
    return responseData;
  } catch (error) {
    console.error(error);
    // Error intentionally not toasted globally - handled on webpage
    stopLoader();
    throw error;
  }
};

const deleteWithQuery = async (route, queryParamsArg = null, token, isToastNeeded = true) => {
  try {
    const URL_ROUTE = `${API_URL}${route}`;
    const headers = {
      ...(token && { Authorization: `${token}` }),
      "Content-Type": "application/json",
    };

    let url = URL_ROUTE;
    if (queryParamsArg) {
      const queryParams = new URLSearchParams(queryParamsArg).toString();
      url += `?${queryParams}`;
    }

    const options = {
      method: 'DELETE',
      headers,
    };

    const response = await fetch(url, options);
    const responseData = await response.json();

    if (response.status === 401 || responseData?.message === "Invalid or expired token") {
      handleSessionExpiry();
      return responseData;
    }

    if (isToastNeeded && response.status === 200) {
      toast.success(responseData.message);
    } else if (isToastNeeded && response.status === 404) {
      // Error intentionally not toasted globally - handled on webpage
    }

    return responseData;
  } catch (error) {
    console.error(error);
    if (isToastNeeded) {
      // Error intentionally not toasted globally - handled on webpage
    }
    throw error;
  }
};

export {
  getData, postData, patchData,
  deleteData, FileUpload, postFileUpload,
  putData, deleteWithQuery
};
